export default "/25f710847dd0be805cb8ee54d4e27cd8317d2a0f/062e30a7ac6b62636e98a277a6442dbf.svg";